import React from 'react'
import { Select, Pagination as Pager } from 'mailup-web-components'
import { useRecoilState } from 'recoil'
import { useIntl } from 'react-intl'
import PropTypes from 'prop-types'
import './Pagination.scss'

import { modalEmailMessagesPaginationState } from 'Hooks/useModalEmailMessages/useModalEmailMessages'

const Pagination = ({ showSizeList = false }) => {
  const intl = useIntl()

  const [{ pageNumber, pageSize, totalItems }, setPageState] = useRecoilState(
    modalEmailMessagesPaginationState
  )

  const handleChangePage = (page) => {
    setPageState((prev) => ({
      ...prev,
      pageNumber: page
    }))
  }

  const handleChangePageSize = (page) => {
    setPageState((prev) => ({
      ...prev,
      pageSize: page
    }))
  }

  return (
    <div className='c-taskslist-pagination'>
      <div className='c-taskslist-pagination__pagenumber'>
        {' '}
        <Pager
          page={pageNumber}
          pageSize={pageSize}
          totalCount={totalItems}
          onChange={handleChangePage}
          data-mu-test='email-messages-pager'
          strings={{ of: intl.formatMessage({ id: 'Load.Pager.Of' }) }}
        />
      </div>
      {showSizeList && totalItems > 5 && (
        <div className='c-taskslist-pagination__pagesize'>
          <Select
            name='pagesize'
            searchable={false}
            value={pageSize}
            options={[5, 10, 20, 50].map((c) => ({
              value: c,
              label: `${c} ${intl.formatMessage({ id: 'Load.Pager.Items' })}`
            }))}
            onChange={handleChangePageSize}
            data-mu-test='select-pagesize'
          />
        </div>
      )}
    </div>
  )
}

Pagination.propTypes = {
  showSizeList: PropTypes.bool
}

Pagination.defaultProps = {
  showSizeList: false
}

export default Pagination
